var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFact3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1768",
    "data-name": "Group 1768",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.949,
    height: 22.4,
    viewBox: "0 0 15.949 22.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    "data-name": "Path 2111",
    d: "M93.308,0a7.742,7.742,0,0,0-7.975,7.467,7.106,7.106,0,0,0,.957,3.548l6.581,11.144a.515.515,0,0,0,.872,0l6.584-11.148a7.105,7.105,0,0,0,.955-3.545A7.742,7.742,0,0,0,93.308,0Zm0,11.2A3.871,3.871,0,0,1,89.32,7.467a4,4,0,0,1,7.975,0A3.871,3.871,0,0,1,93.308,11.2Z",
    transform: "translate(-85.333)",
    fill: "#3f2566"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFact3);
export default __webpack_public_path__ + "static/media/fact3.ae598ef0316e168ac111a79c8e16a48d.svg";
export { ForwardRef as ReactComponent };